import { render } from "./CarouselLenta.vue?vue&type=template&id=f6ad35ba&scoped=true"
import script from "./CarouselLenta.vue?vue&type=script&lang=js"
export * from "./CarouselLenta.vue?vue&type=script&lang=js"

import "./CarouselLenta.vue?vue&type=style&index=0&id=f6ad35ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ad35ba"]])

export default __exports__